export const legacyTypes = {
  LIST_LEGACY: 'LIST_LEGACY_PROTOCOL_VERSION',
  LIST_LEGACY_SUCCESS: 'LIST_LEGACY_PROTOCOL_VERSION_SUCCESS',
  LIST_LEGACY_FAIL: 'LIST_LEGACY_PROTOCOL_VERSION_FAIL',
  
};
